














import { Vue, Component } from 'vue-property-decorator';

@Component({
    components: {},
})
export default class footerBar extends Vue {
    public year: number = new Date().getFullYear();
    openIcp() {
        window.open('http://www.beian.miit.gov.cn/', '_blank');
    }
}
